import React, { memo, Suspense } from 'react'

import Blogs from '@/components/Blogs/Blogs'
import Navigation from '@/components/Navigation/Navigation'

interface Props {}

const BlogsPage: React.FC<Props> = memo(() => {
  return (
    <>
      <Blogs />
    </>
  )
})
BlogsPage.displayName = 'BlogsPage'

export default BlogsPage
